import { useEffect, useState } from "react";
import { api } from "./api";
import { useLocale } from "../i18n";

// One canonical source for every categorical list (GET /api/taxonomies), cached per locale for the session.
const cache = {};
export const loadTaxonomies = (lang) =>
  (cache[lang] ||= api.get("/taxonomies", { params: { lang } }).then((r) => r.data).catch((e) => {
    delete cache[lang];
    throw e;
  }));
export const resetTaxonomies = () => Object.keys(cache).forEach((k) => delete cache[k]);

export const useTaxonomies = (forced) => {
  const locale = useLocale();
  const lang = forced || locale || "en";
  const [tx, setTx] = useState(null);
  const [rev, setRev] = useState(0);
  useEffect(() => {
    let active = true;
    loadTaxonomies(lang).then((d) => active && setTx(d)).catch(() => {});
    return () => {
      active = false;
    };
  }, [lang, rev]);
  return [tx, () => { resetTaxonomies(); setRev((n) => n + 1); }];
};

export const labelOf = (tx, kind, key) => (key && tx?.[kind]?.find((r) => r.key === key)?.label) || "";

export const countryList = (tx, lang) => {
  const rows = (tx?.countries || []).map((c) => ({ code: c.key, name: c.label }));
  const collator = new Intl.Collator(lang);
  rows.sort((a, b) => (a.code === "JP" ? -1 : b.code === "JP" ? 1 : collator.compare(a.name, b.name)));
  return rows;
};
